// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"51d10347","198":"65fe36f9","234":"6c10d64a","239":"820f6855","409":"23d3435d","453":"55c1ae11","496":"1b7d058e","603":"83d17bd7","662":"a4d8ce08","732":"569ae071","738":"57b3288e","939":"c24b04ff","956":"c8ddeeb4","977":"a7a2ed99"}[chunkId] + ".chunk.js";
};